/**
 * SubRow — fila de sub-lista dentro de una tarjeta de detalle (patrón V2 del
 * handoff: dominios publicados, envíos, reservas, fechas bloqueadas). Fila
 * bordeada con título ellipsado a la izquierda, meta en caption y un slot
 * derecho para pill o acciones. Los estilos salen de los tokens --evo-subrow-*.
 */
import type { ReactNode } from 'react';

interface SubRowProps {
  title: ReactNode;
  /** Texto secundario en caption, pegado al slot derecho. */
  meta?: ReactNode;
  /** Pill de estado o acciones (IconButton). */
  right?: ReactNode;
  /** Slot izquierdo previo al título (checkbox de selección). */
  left?: ReactNode;
  onClick?: () => void;
}

export function SubRow({ title, meta, right, left, onClick }: SubRowProps) {
  return (
    <div
      className="evo-subrow"
      data-clickable={onClick ? '' : undefined}
      onClick={onClick}
    >
      {left != null && (
        <span style={{ flexShrink: 0, display: 'inline-flex', alignItems: 'center' }}>
          {left}
        </span>
      )}
      <span
        style={{
          flex: 1,
          minWidth: 0,
          fontSize: 'var(--evo-list-title-fs)',
          fontFamily: 'var(--evo-font)',
          color: 'var(--evo-fg-2)',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {title}
      </span>
      {meta != null && (
        <span
          style={{
            flexShrink: 0,
            fontSize: 'var(--evo-fs-caption)',
            fontFamily: 'var(--evo-font)',
            color: 'var(--evo-fg-3)',
            whiteSpace: 'nowrap',
          }}
        >
          {meta}
        </span>
      )}
      {right != null && (
        <span style={{ flexShrink: 0, display: 'inline-flex', alignItems: 'center', gap: 'var(--evo-space-1)' }}>
          {right}
        </span>
      )}
    </div>
  );
}

/** Contenedor vertical de SubRows con el gap canónico del patrón. */
export function SubRowList({ children }: { children: ReactNode }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--evo-space-1)' }}>
      {children}
    </div>
  );
}
